<template>
  <div>
    <div v-if="isShowPanel == 0">
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>库存管理</el-breadcrumb-item>
          <el-breadcrumb-item><span style="color:#000;font-weight:bold;">入库单</span></el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <list-top :form="form" @search="search" class="list-top-margin" :goodsShow="true"></list-top>
      </div>
      <div class="white-background">

          <el-row class="tbl-btn">
            <el-col :span="12" class="tbl-btn-left">
              <el-button size="small" type="primary" icon="el-icon-plus" @click="createSaleOrder">创建入库单</el-button>
              <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
                <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button type="text" icon="el-icon-edit-outline">编辑打印模板</el-button> -->
              <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportDataNew">导出</el-button>
            </el-col>
            <!-- <el-col :span="12" class="tbl-btn-right">
              <el-button type="primary" size="small" icon="el-icon-setting">移动端卡片配置</el-button>
              <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
            </el-col> -->
          </el-row>
          <!--列表-->
          <el-table
          ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          element-loading-text="加载中"
          :header-cell-style="_headerStyle"
          style="width: 100%;"
          @selection-change="handleTblSelectionChange"
          row-key="_id"
          >

            <el-table-column  type="expand">
              <template slot-scope="props">
                <el-table
                  size="small"
                  :data="props.row.instockList"
                  highlight-current-row
                  stripe
                  :header-cell-style="_headerStyle"
                  style="width: calc(100% - 50px);margin-left:50px;"
                  max-height="250px"
                  >
                  <el-table-column label="产品编号" width="150">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.productCode" placement="top">
                        <span class="txt-overflow">{{scope.row.productCode}}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column label="产品名称" width="150">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.productName" placement="top">
                        <span class="txt-overflow">{{scope.row.productName}}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="specs" label="产品规格" ></el-table-column>
                  <el-table-column prop="source" label="产品属性" ></el-table-column>
                  <el-table-column prop="unit" label="库存单位" ></el-table-column>
                  <el-table-column prop="instockNum" label="入库数量" ></el-table-column>

                </el-table>

              </template>
            </el-table-column>
            <el-table-column align="left" type="selection" :reserve-selection="true" width="60">
            </el-table-column>
            <el-table-column align="left" type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column sortable prop="instockCode" label="入库单号" width="150">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.instockCode" placement="top">
                  <span class="txt-overflow" >{{scope.row.instockCode}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="入库类型" width="150" sortable>
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.instockType" placement="top">
                  <span class="txt-overflow">{{scope.row.instockType}}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="入库时间" width="150" sortable>
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.instockTime" placement="top">
                  <span class="txt-overflow">{{scope.row.instockTime}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="100">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"  sortable>
            </el-table-column>
            <el-table-column prop="creater" label="创建人" >
            </el-table-column>
             <el-table-column prop="updater" label="更新人" >
            </el-table-column>

            <el-table-column prop="updateTime" label="更新时间"  sortable>
            </el-table-column>
            <!-- <el-table-column prop="updater" label="更新人" width="100">
            </el-table-column> -->

            <!-- <el-table-column prop="deptNo" label="来源单据类型" width="100">
            </el-table-column>
            <el-table-column prop="deptNo" label="来源单据" width="120">
            </el-table-column> -->
            <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>

            <el-table-column align="left"  label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <!-- <el-tooltip content="打印">
                  <el-button type="primary" size="mini" icon="el-icon-printer" circle @click="handleEdit(scope.$index, scope.row)"></el-button>
                </el-tooltip> -->
                <el-tooltip content="编辑">
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle  @click="handleEdit(scope.$index, scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
    </div>
    <CreateLayout v-if="isShowPanel == 1" @goBack="goBack" :userData="userData" :mode="mode" :editRow="editRow" :setList="setList"></CreateLayout>
  </div>
</template>

<script>
import { instockGetList,instockDelete,instockBatchDelete} from '@/api/basicData';
import { queryAllCustomSet} from '@/api/business';

import CreateLayout from './CreateLayout.vue';
import Pagination from '@/components/Pagination';
import ListTop from './ListTop.vue';
import {exportDataToExcel} from '@/utils/util';

export default {
  watch:{
    tblSelectionList(newList,oldList){
      this.isBatchPrint = (newList && newList != null && newList.length > 0);

    }
  },
  data() {
    return {
      isShowPanel:0,
      isBatchPrint:false,
      isSearchPanelShow:false,
      tblSelectionList:[],
      //--------------------------
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      form: {
        factoryId:"",

      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      userData:{},
      mode:'',
      editRow:{},
      setList:[],
    }
  },
  // 注册组件
  components: {
    Pagination,
    CreateLayout,
    ListTop
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.form['factoryId'] = this.userData.factoryId;
      this.init()
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        tableName:'入库单',
        collection:'instock',
      }
      //params.condition[this.searchSelectValue] = this.searchInputValue

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "入库单清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

    },
     //导出数据前对数据处理，变为想要的格式。
     filterTableData(data) {
      data.forEach((item) => {
        item.productCode = item.productInfo?item.productInfo.productCode:'';
        item.productName = item.productInfo?item.productInfo.productName:'';
        item.specs = item.productInfo?item.productInfo.specs:'';
        item.unit = item.productInfo?item.productInfo.unit:'';

      });
      return data;
    },
    exportDataNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){

        this.exportData();
        return;
      }
      const header = [

        '入库单号',
        '入库类型',
        '入库时间',
        '备注',
        '创建时间',
        '创建人',
        '更新时间',
        '更新人',
        "产品编号",
        '产品名称',
        '产品规格',
        '产品属性',
        '库存单位',
        '入库数量',


      ];
      const filterVal = [

        'instockCode',
        'instockType',
        'instockTime',
        'remark',
        'createTime',
        'creater',
        'updateTime',
        'updater',
        'productCode',
        'productName',
        'specs',
        'source',
        'unit',
        'instockNum',


      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let selectData =  [];
      for(let j = 0;j < this.tblSelectionList.length;j++){
        let p = this.tblSelectionList[j];
        if(p.instockList && p.instockList.length > 0){
          for(let i = 0;i < p.instockList.length;i++){
            let temp ={
              'instockCode':p.instockCode,
              'instockType':p.instockType,
              'instockTime':p.instockTime,

              'productCode':p.instockList[i].productCode,
              'productName':p.instockList[i].productName,
              'instockNum':p.instockList[i].instockNum,
              'specs':p.instockList[i].specs,
              'source':p.instockList[i].source,
              'unit':p.instockList[i].unit,

              'createTime':p.createTime,
              'creater':p.creater,
              'updater':p.updater,
              'updateTime':p.updateTime,
            };

            for(let k = 0;k<this.setList.length;k++){
              temp[this.setList[k]['fieldName']] = p[this.setList[k]['fieldName']];
            }
            selectData.push(temp)
          }
        }else{
          let temp = {
            'instockCode':p.instockCode,
            'instockType':p.instockType,
            'instockTime':p.instockTime,

            'productCode':"",
            'productName':"",
            'instockNum':"",
            'specs':"",
            'source':"",
            'unit':"",

            'createTime':p.createTime,
            'creater':p.creater,
            'updater':p.updater,
            'updateTime':p.updateTime,
          };
          for(let k = 0;k<this.setList.length;k++){
            temp[this.setList[k]['fieldName']] = p[this.setList[k]['fieldName']];
          }
          selectData.push(temp)
        }


      }
      let filterData =JSON.parse(JSON.stringify(selectData));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"入库单清册"+Date.now());
    },
     init(){
      queryAllCustomSet(this.userData.factoryId,'instock').then(res=>{
        this.setList = [];
        if(res['code'] == 200){
          this.setList = res['data'];
          this.getdata();
        }
      })
    },
    search(){
      this.pageparm.currentPage = 1
      this.pageparm.pageSize = 10
      this.getdata()
    },
    getdata() {
      this.loading = true
      let con = JSON.parse(JSON.stringify(this.form));
      if(this.form.instockTime){
        if(this.form.aprovalCondition == "between" && this.form.instockTime.length == 2){
          con.instockTime = {
            begin:this.form.instockTime[0].substring(0,10) + " 00:00:00",
            end:this.form.instockTime[1].substring(0,10) + " 23:59:59",
            type:this.form.aprovalCondition,
            data:'time'
          }
        }else{
          con.instockTime = {
            type:this.form.aprovalCondition,
            value:this.form.instockTime,
            data:'time'
          }
        }
      }
      if(this.form.createTime){
        if(this.form.createCondition1 == "between" && this.form.createTime.length == 2){
          con.createTime = {
            begin:this.form.createTime[0],
            end:this.form.createTime[1],
            type:this.form.createCondition1,
            data:'time'
          }
        }else{
          con.createTime = {
            type:this.form.createCondition1,
            value:this.form.createTime,
            data:'time'
          }
        }
      }
      if(this.form.updateTime){
        if(this.form.updateCondition1 == "between" && this.form.updateTime.length == 2){
          con.updateTime = {
            begin:this.form.updateTime[0],
            end:this.form.updateTime[1],
            type:this.form.updateCondition1,
            data:'time'
          }
        }else{
          con.updateTime = {
            type:this.form.updateCondition1,
            value:this.form.updateTime,
            data:'time'
          }
        }
      }
      delete con.approvalValue;
      delete con.aprovalCondition;
      delete con.createCondition1;
      delete con.dynamicCreateValue;
      delete con.dynamicUpdateValue;
      delete con.updateCondition1;
      var params = {
        condition:con,
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      instockGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.mode = 'upate'
        this.editRow = row;
        this.isShowPanel = '1';
        // this.editForm.deptId = row.deptId
        // this.editForm.deptName = row.deptName
        // this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        // if (valid) {
        //   deptSave(this.editForm)
        //     .then(res => {
        //       this.editFormVisible = false
        //       this.loading = false
        //       if (res.success) {
        //         this.getdata(this.form)
        //         this.$message({
        //           type: 'success',
        //           message: '公司保存成功！'
        //         })
        //       } else {
        //         this.$message({
        //           type: 'info',
        //           message: res.msg
        //         })
        //       }
        //     })
        //     .catch(err => {
        //       this.editFormVisible = false
        //       this.loading = false
        //       this.$message.error('公司保存失败，请稍后再试！')
        //     })
        // } else {
        //   return false
        // }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    handleDelete(index,row){
      this.$confirm('确认删除入库单？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          instockDelete(row).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          instockBatchDelete(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    //-------------------
    /**
     * 控制查询面板显示隐藏
     */
    expandClick(){
      this.isSearchPanelShow = !this.isSearchPanelShow;
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val){
      this.tblSelectionList = val;
    },
    createSaleOrder(){
      //this.$router.push({path:'/goods/Goods/create'});
      this.mode = 'create'
      this.isShowPanel = 1;
    },
    goBack(options){
      this.isShowPanel = 0;
      if(options && options.type == 'save'){
        this.getdata()
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.el-divider--horizontal{
  margin: 10px 0px;
}
.date-picker{
  width: 100% !important;

}
.el-input__inner{
  height: 32px;
  line-height: 32px;
  padding: 0px 10px;
}
.el-form-item{
  margin-bottom: 10px;
}
.tbl-btn{
  width: 100%;
  height: 50px;
  line-height: 50px;

}
.tbl-btn .tbl-btn-right{
  text-align: right;
}
.tbl-pagination{
  text-align: right;
}
.txt-overflow{
  text-overflow:ellipsis;
  white-space:nowrap;
}
</style>





// WEBPACK FOOTER //
// src/views/stockManagement/warehousingOrder/WarehousingOrder.vue